import { API_ENDPOINTS } from '../endpoints';

export const getProductPrice = async (protectedClient, productId) => {
    const response = await protectedClient.get(API_ENDPOINTS.PRODUCT, {
        params: { productId }
    });
    return response.data.data;
};

export const createOrder = async (protectedClient, productId, amount, totalPrice, orderType) => {
    const response = await protectedClient.post(API_ENDPOINTS.ORDER, {productId, amount, totalPrice, orderType});
    return response.data.data;
};

export const getOrders = async (protectedClient) => {
    const response = await protectedClient.get(API_ENDPOINTS.ORDER);
    return response.data.data;
};